import { Ads } from "../types"

export enum AdTypes {
  FixedBanner = "banner",
  Tile = "tile",
  InArticleStandard = "in_article_standard",
}
